// The Instructor(s) cell: the first two active instructors as neutral badges that truncate, and the rest
// behind a neutral +N badge. The row sits inside a clipped value, so the table's content floor treats the
// badges as truncating content rather than as fixed-width badges.

import React from 'react'
import PropTypes from 'prop-types'

import {
  ClippedValue,
  Tooltip,
} from '../../components/me_table/tooltip/Tooltip'

export const SHOWN_INSTRUCTORS = 2
export const NO_INSTRUCTOR = 'No active instructor'

/** The house empty cell: a muted dash carrying its own accessible name. */
export const Dash = ({ label }) => (
  <span className="admin-courses-dash" role="img" aria-label={label}>
    —
  </span>
)

Dash.propTypes = { label: PropTypes.string.isRequired }

export const moreLabel = rest => `${rest.length} more: ${rest.join(', ')}`

export const InstructorBadges = ({ row }) => {
  const emails = Array.isArray(row.instructors) ? row.instructors : []
  if (!emails.length) return <Dash label={NO_INSTRUCTOR} />
  const shown = emails.slice(0, SHOWN_INSTRUCTORS)
  const rest = emails.slice(SHOWN_INSTRUCTORS)
  return (
    <span className="me-table-clipped admin-courses-instructors">
      {shown.map((email, index) => (
        <span
          key={`${email}-${index}`}
          className="me-badge-tint me-badge-tint-neutral admin-courses-email"
        >
          <ClippedValue text={email} />
        </span>
      ))}
      {rest.length > 0 && (
        <Tooltip text={moreLabel(rest)}>
          <span
            className="me-badge-tint me-badge-tint-neutral admin-courses-more"
            role="note"
            tabIndex={0}
            aria-label={moreLabel(rest)}
          >
            +{rest.length}
          </span>
        </Tooltip>
      )}
    </span>
  )
}

InstructorBadges.propTypes = {
  row: PropTypes.shape({ instructors: PropTypes.arrayOf(PropTypes.string) })
    .isRequired,
}
